import type { MessageAttachmentDto, MessageDto } from "@multi-chat/shared";

export const PENDING_ATTACHMENT_POLL_BASE_MS = 2_000;
export const PENDING_ATTACHMENT_POLL_MAX_MS = 15_000;
export const PENDING_ATTACHMENT_POLL_MAX_ATTEMPTS = 60;

export function attachmentNeedsStorageReconciliation(
  storageState: MessageAttachmentDto["storageState"],
): boolean {
  return storageState === "PENDING_STORAGE";
}

export function messagesHavePendingStorageAttachments(messages: readonly MessageDto[]): boolean {
  for (const message of messages) {
    for (const attachment of message.attachments ?? []) {
      if (attachmentNeedsStorageReconciliation(attachment.storageState)) {
        return true;
      }
    }
  }
  return false;
}

/** Bounded backoff for open-thread attachment reconciliation polling. */
export function nextPendingAttachmentPollDelayMs(attempt: number): number {
  const scaled = PENDING_ATTACHMENT_POLL_BASE_MS * 1.5 ** Math.min(attempt, 8);
  return Math.min(PENDING_ATTACHMENT_POLL_MAX_MS, Math.round(scaled));
}

export function shouldContinuePendingAttachmentPolling(
  attempt: number,
  hasPending: boolean,
): boolean {
  if (!hasPending) {
    return false;
  }
  return attempt < PENDING_ATTACHMENT_POLL_MAX_ATTEMPTS;
}
